import { computed, unref } from 'vue';

import { REPORT_CATEGORY_OPTIONS } from '@/app/dashboards/utils/reports.enum';

export function useReportCategory({ reportCategory } = {}) {
  const category = computed(() => unref(reportCategory));

  const categoryConfig = computed(() =>
    Object.values(REPORT_CATEGORY_OPTIONS).find((config) => config.id === category.value),
  );

  const isCommunityReportCategory = computed(
    () => category.value === REPORT_CATEGORY_OPTIONS.COMMUNITY.id || false,
  );

  const isEarnedReportCategory = computed(
    () => category.value === REPORT_CATEGORY_OPTIONS.EARNED.id || false,
  );

  const isIndustryReportCategory = computed(
    () => category.value === REPORT_CATEGORY_OPTIONS.INDUSTRY.id || false,
  );

  const isListeningReportCategory = computed(
    () => category.value === REPORT_CATEGORY_OPTIONS.SOCIAL_LISTENING.id || false,
  );

  const isTSIReportCategory = computed(
    () => category.value === REPORT_CATEGORY_OPTIONS.TSI.id || false,
  );

  const isCompetitiveCategory = computed(
    () => category.value === REPORT_CATEGORY_OPTIONS.COMPETITIVE.id || false,
  );

  const isOwnedReportCategory = computed(() => category.value === REPORT_CATEGORY_OPTIONS.OWNED.id);

  const isAdsReportCategory = computed(
    () => category.value === REPORT_CATEGORY_OPTIONS.SOCIAL_ADVERTISING.id,
  );

  const hasLockedMetric = computed(() => !!categoryConfig.value?.lockedMetric);

  const hasLockedChannels = computed(() => !!categoryConfig.value?.lockedChannels);

  return {
    categoryConfig,
    isAdsReportCategory,
    isCommunityReportCategory,
    isCompetitiveCategory,
    isEarnedReportCategory,
    isIndustryReportCategory,
    isListeningReportCategory,
    isOwnedReportCategory,
    isTSIReportCategory,
    hasLockedMetric,
    hasLockedChannels,
  };
}
